<template>
  <div id="myapp" style="border:1px solid red;">
    dfgsdgsdgsgs
  </div>
</template>


<script>

export default {
  name: "mainpage",
  components: {
    
  },
  created() {
    debugger
  },

  data: function() {
    return {
      
    };
  },

  methods: {
    
  },
  
};
</script>

<style lang="scss">

</style>
